<template>
  <nav>
    <v-navigation-drawer v-model="drawer" app :clipped="$vuetify.breakpoint.lgAndUp">
      <v-list>
        <v-list-item v-for="link in links" :key="link.text" router :to="link.route">
          <v-list-item-action>
            <v-icon class="grey--text">{{ link.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="grey--text">
              {{
              link.text
              }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app flat class="primary" :clipped-left="$vuetify.breakpoint.lgAndUp">
      <v-app-bar-nav-icon class="white--text"></v-app-bar-nav-icon>
      <v-toolbar-title style="width: 300px" class="ma-0 pa-0">
        <v-img
          src="../assets/nutechlogo.png"
          contain
          max-height="43"
          max-width="96"
          class="ml-4 pa-0"
        ></v-img>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn text>
        <v-icon class="white--text">mdi-map-marker</v-icon>
        <span class="text-none ml-3 white--text">Nutech Security | Headoffice</span>
      </v-btn>
      <v-btn text @click="setAudioOn()" class="error" id="soundcontrolbtn">
        <v-icon class="white--text">{{ soundon }}</v-icon>
        <span class="text-none ml-3 white--text">{{ soundtext }}</span>
      </v-btn>

      <v-btn text>
        <v-icon lfet class="white--text">mdi-account</v-icon>
        <span class="text-none ml-3 white--text">Admin</span>
      </v-btn>
    </v-app-bar>
  </nav>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      soundon: "mdi-volume-off",
      soundtext: "Panic audio off",
      drawer: null,
      links: [
        { icon: "mdi-map-marker", text: "Nutech Security", route: "/" },
        { icon: "mdi-map-marker", text: "Client One", route: "/client/one" },
        { icon: "mdi-map-marker", text: "Client Two", route: "/client/two" },
        { icon: "mdi-map-marker", text: "Client Three", route: "" },
        { icon: "mdi-map-marker", text: "Client Four", route: "" },
        { icon: "mdi-map-marker", text: "Client Five", route: "" },
        { icon: "mdi-map-marker", text: "Client Six", route: "" },
        { icon: "mdi-map-marker", text: "Client Seven", route: "" },
        { icon: "mdi-map-marker", text: "Client Eight", route: "" },
        { icon: "mdi-map-marker", text: "Client Nine", route: "" },
        { icon: "mdi-map-marker", text: "Client Ten", route: "" },
        { icon: "mdi-map-marker", text: "Client Eleven", route: "" },
        { icon: "mdi-map-marker", text: "Client Twelve", route: "" },
        { icon: "mdi-map-marker", text: "Client Thirteen", route: "" },
        { icon: "mdi-map-marker", text: "Client Fourteen", route: "" },
        { icon: "mdi-map-marker", text: "Client Fifteen", route: "" },
        { icon: "mdi-map-marker", text: "Client Sixteen", route: "" }
      ]
    };
  },
  created: function() {
    document.body.addEventListener("click", () => {
      this.setAudioOn();
    });
  },
  methods: {
    setAudioOn: function() {
      this.soundon = "mdi-volume-high";
      this.soundtext = "Panic audio on";
      document.getElementById("soundcontrolbtn").classList.remove("error");
      document.getElementById("soundcontrolbtn").classList.add("success");
    }
  }
};
</script>

<style scoped>
.breadcrumbdata {
  position: relative;
  top: 300px;
  left: 20px;
}
</style>
